export default class Tabs {
  constructor(element) {
    this.$el = $(element);
    this.$tabTriggers = this.$el.find('[data-js-tab-trigger]')
    this.$tabContent = $('[data-js-tab-content]')
    this.$tabSelect = this.$el.find('[data-js-tab-select]')
    this.init();
  }

  init() {
    const {$tabTriggers, $tabContent, $tabSelect} = this

    $tabTriggers.on('click', function (e) {
      e.preventDefault()

      if ($(this).hasClass('active')) {
        return
      }

      $tabTriggers.removeClass('active')
      $(this).addClass('active')
      const value = $(this).data('js-tab-trigger')
      $tabContent.removeClass('active')
      $(`[data-js-tab-content="${value}"]`).addClass('active')
    })

    $tabSelect.on('change', () => {
      $tabContent.removeClass('active')
      $(`[data-js-tab-content="${$tabSelect.val()}"]`).addClass('active')

    })
  }
}
